import { PaymentMethodType } from "ts/api/paymentMethod";
import {
  BankTransferOrder,
  CardOrder,
  IdealOrder,
  RawOrder,
} from "ts/api/order";

const CARD_IDEAL_TYPES = [
  PaymentMethodType.idealPayment,
  PaymentMethodType.cardPayment,
] as string[];

export const isOrderCardOrIdeal = (
  order: RawOrder
): order is CardOrder | IdealOrder =>
  CARD_IDEAL_TYPES.includes(order.paymentType);

export const isOrderBankTransfer = (
  order: RawOrder
): order is BankTransferOrder =>
  order.paymentType === PaymentMethodType.bankTransfer;
